import { Box, TextField, TextFieldProps } from "@mui/material";

const TextFieldWithButton = ({
  addButtonText,
  addButtonAction,
  ...props
}: { addButtonText: string; addButtonAction: () => void } & TextFieldProps) => {
  return (
    <Box sx={styles.container}>
      <TextField {...props} sx={styles.textField} />
      <Box component="button" sx={styles.button} onClick={() => addButtonAction()}>
        {addButtonText}
      </Box>
    </Box>
  );
};

export default TextFieldWithButton;

const styles = {
  container: {
    display: "flex",
    width: "100%",
    borderRadius: "8px !important",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    overflow: "hidden",
  },
  textField: {
    flex: 1,
    borderRadius: "0 !important",
    border: "none !important",
    background: "var(--Base-White, #FFF)",
    "& .MuiOutlinedInput-root": {
      border: "none",
    },
  },
  button: {
    borderRadius: "0 8px 8px 0",
    background: "var(--Base-White, #FFF)",
    padding: "10px 16px",
    color: "var(--Gray-700, #344054)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    outline: "none",
    border: "none",
    borderLeft: "1px solid var(--Gray-300, #D0D5DD)",
    cursor: "pointer",
  },
};
